// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2OkQU","clinicsSelect":"TableHeading_clinicsSelect__2ovAP"};